import CreativeFileStatus from '@/Enums/Creatives/CreativeFileStatus.enum';
import type { ILineItemCreative } from '@/Interfaces/CampaignManagement/LineItem.interface';
import CreativeTypeService from '@/Services/Creative/CreativeType.service';
import { CREATIVE_ASSIGNMENT_DISABLED_REASON } from '@/constants/creativeLibrary';
import { Checkbox, Tooltip } from '@mui/material';
import { GRID_CHECKBOX_SELECTION_COL_DEF, GridCellCheckboxRenderer, GridRenderCellParams } from '@mui/x-data-grid-pro';

const CheckboxCell = {
  ...GRID_CHECKBOX_SELECTION_COL_DEF,
  flex: 0.2,
  maxHeight: 50,
  display: 'flex',
  renderCell: (params: GridRenderCellParams<ILineItemCreative>) => {
    const { row: creative } = params;

    if (
      (CreativeTypeService.isInline(creative.type) &&
        [CreativeFileStatus.PROCESSING, CreativeFileStatus.FAILED, null].includes(creative.fileStatus)) ||
      !creative.beeswaxId
    ) {
      const reason = creative.beeswaxId
        ? (creative.fileStatus as CreativeFileStatus.PROCESSING | CreativeFileStatus.FAILED)
        : 'noBeeswaxId';
      return (
        <Tooltip className='absolute' title={CREATIVE_ASSIGNMENT_DISABLED_REASON[reason]} placement='top' arrow>
          <span>
            <Checkbox disabled />
          </span>
        </Tooltip>
      );
    }

    return <GridCellCheckboxRenderer {...params} />;
  },
};
export default CheckboxCell;
